export default __webpack_public_path__ + "static/media/115_mobile.0c8cab42.jpg";